import { createFileRoute } from '@tanstack/react-router';
// Will be lazy loaded from MFE
export const Route = createFileRoute('/org/$organization/$project/app/$application/devops/tags/add')({
    component: ()=>null
});
